var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "温馨提示",
            visible: _vm.commissionTypeDialog,
            "append-to-body": "",
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.commissionTypeDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formOrder",
              staticClass: "myForm",
              attrs: { inline: "", model: _vm.formOrder },
            },
            [
              _c("el-form-item", { attrs: { label: "" } }, [
                _c(
                  "div",
                  {
                    staticStyle: { color: "red" },
                    attrs: { slot: "label" },
                    slot: "label",
                  },
                  [
                    _vm._v(
                      " 订单规则中增加了第三方资源菜单，请确定佣金业绩核算方式 "
                    ),
                  ]
                ),
              ]),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "佣金核算方式",
                    prop: "commission_type",
                    rules: [
                      {
                        required: true,
                        message: "请选择佣金核算方式",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.formOrder.commission_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.formOrder, "commission_type", $$v)
                        },
                        expression: "formOrder.commission_type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("自动核算"),
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("人工未核算"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("人工已核算"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "medium", plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.commissionTypeDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "20px" },
                  attrs: { type: "primary", size: "medium" },
                  on: { click: _vm.upSettlementType },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }